export default {
  namespaced: true,
  state: {
    termsChecked: [false, false, false, false, false],

  },
  mutations: {
    reset(state) {
      state.termsChecked = [false, false, false, false, false];
    },
    updateCheckedWithIndex(state, value) {
      state.termsChecked[value.index] = value.checked;
    },
  },
  getters: {
    getAllTerms(state) {
      return state.termsChecked;
    },
  }
}
